import { PublicSidebarCustomCommandProps, SidebarCustomComponents, SidebarPublicPort } from '@features/sidebar';

export function openSizeGuideUseCase(store, product, categoryId): void {
    const props: PublicSidebarCustomCommandProps = {
        component: SidebarCustomComponents.SIZE_GUIDE,
        initializeFunction: undefined,
        data: {
            product, categoryId,
        },
    };
    SidebarPublicPort(store).openSidebarCustom(props);
}
